import { render, staticRenderFns } from "./formExpensesAccount.vue?vue&type=template&id=3a3c13da"
import script from "./formExpensesAccount.vue?vue&type=script&lang=js"
export * from "./formExpensesAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports